export default {
  tokenHeader: 'Authorization',
  tokenPrefix: 'petrochem-admin',
  loginUrl: '/auth/admin_login',
  tokenPath: 'token',
};
